import { Alignment, HorizontalPadding, TopPadding } from '@easeltv/client-sdk';

import {
    StyledFooterText,
    StyledFooterTextBlock,
} from './FooterTextBlock.styled';

/* ---------------------------------- Types --------------------------------- */

/** @interface `DumbFooterTextBlockI`
 * #### Interface for the DumbFooterTextBlock's props object
 */
export interface DumbFooterTextBlockI {
    /** copy to be displayed */
    text: string;

    /** controls copy and container alignment inside the footer */
    alignment: Alignment;

    /** controls left and right spacing of the copy */
    horizontalPadding: HorizontalPadding;

    /** controls amount of space above the copy */
    topPadding: TopPadding;
}

/* -------------------------------- Component ------------------------------- */

/**
 * DumbFooterTextBlock
 *
 * @param props DumbFooterTextBlockI
 * @returns JSX.Element
 */
const DumbFooterTextBlock = ({
    text,
    alignment,
    horizontalPadding,
    topPadding,
}: DumbFooterTextBlockI) => {
    const adjustedHorizontalPadding =
        alignment === Alignment.Center
            ? HorizontalPadding.None
            : horizontalPadding;
    return (
        <StyledFooterTextBlock
            alignment={alignment}
            topPadding={topPadding}
            horizontalPadding={adjustedHorizontalPadding}
        >
            <StyledFooterText>{text}</StyledFooterText>
        </StyledFooterTextBlock>
    );
};

/* --------------------------------- Export --------------------------------- */

export default DumbFooterTextBlock;
